var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('img',{attrs:{"src":_vm.icon,"alt":"","uk-svg":""}})]),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.title))]),_c('br'),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }